import { Table } from '@mantine/core';
import { useParams } from 'react-router';
import { LoadingRows } from '../../../components/LoadingRows';
import { query } from '../../../util/api/query';
import type { DepartmentDto } from '../../departments/types/DepartmentDto';
import { GroupTotalDepartmentRow } from './GroupTotalDepartmentRow';

interface DepartmentViewProps {
	groupId: number;
	startLoading: boolean;
}

export function DepartmentTable({
	groupId,
	startLoading,
}: DepartmentViewProps) {
	const { organisation } = useParams();

	const departmentsQuery = query<DepartmentDto[]>(
		`${organisation}/group-totals/get-departments-with-stats/${groupId}`,
		startLoading,
	);

	return (
		<Table highlightOnHover withRowBorders pt={0} mt={0}>
			<Table.Tbody>
				{departmentsQuery.isLoading ? (
					<LoadingRows columnSpan={1} rows={1} />
				) : (
					<>
						{departmentsQuery.data?.value.map((d) => (
							<GroupTotalDepartmentRow key={d.id} department={d} />
						))}
					</>
				)}
			</Table.Tbody>
		</Table>
	);
}
